import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useCompaniesContext } from 'company/context'
import { AddEditUserScreenProps } from 'home/stack/types'
import { useAddEditUserContext } from 'management_team/context'
import { useManagementTeamActions } from 'management_team/management_actions_context'
import { useCompanyStores } from 'management_team/queries/stores'
import { useCallback, useLayoutEffect } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderButton } from 'shared/header/header_button'
import { showHeaderTitle } from 'shared/header/header_title'
import { AddEditUserView } from './views'

export function AddEditUserScreen({
  navigation,
  route,
}: AddEditUserScreenProps) {
  const { theme } = useTheme()
  const { handleNavigation } = useRoutingContext()
  const { activeCompany } = useCompaniesContext()
  const { userFields, setUserFields, type, role, isValid } =
    useAddEditUserContext()
  const { onEditUser, onAddUser } = useManagementTeamActions()
  const companyStoresQuery = useCompanyStores(activeCompany?.id)

  const onSubmit = useCallback(() => {
    if (type === 'add') {
      onAddUser(userFields)
    } else {
      onEditUser(userFields)
    }

    handleNavigation({
      routeName: 'management_team',
    })
  }, [handleNavigation, type, onAddUser, userFields, onEditUser])

  const onPressChooseStores = useCallback(() => {
    handleNavigation({ routeName: 'observer_store_chooser' })
  }, [handleNavigation])

  useLayoutEffect(() => {
    showHeaderTitle(
      navigation,
      type === 'editUser' ? t('editTeamMember') : t('addTeamMember')
    )
  }, [navigation, type])

  useLayoutEffect(() => {
    showHeaderButton({
      navigation,
      theme,
      title: t('submit'),
      onPress: () => onSubmit(),
      position: 'right',
      useIcon: false,
      disabled: !isValid(),
    })
  }, [onSubmit, navigation, userFields, theme, isValid])

  return (
    <StatusBoundary isLoading={companyStoresQuery.isLoading} error={undefined}>
      <AddEditUserView
        userFields={userFields}
        setUserFields={setUserFields}
        stores={companyStoresQuery.data}
        role={role}
        onPressChooseStores={onPressChooseStores}
      />
    </StatusBoundary>
  )
}
